import React, { Component } from 'react';

import InfoSuperior from './InfoSuperior';
import ControlesSuperiores from './ControlesSuperiores';
import TablaErrores from './TablaErrores';
import ModalConfirmarSalir from '../ModalConfirmarSalir';
import ModalDatosCuenta from '../../../DatosCuenta/components/ModalDatosCuenta';

class DetalleErrores extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.RecorrerTabla = this.RecorrerTabla.bind(this);
    }

    RecorrerTabla() {
        this.props.RecorrerTabla();
    }

    render() {
        const { data } = this.props;

        let datosProcesosAux = JSON.parse(JSON.stringify(data.datosProcesos));
        datosProcesosAux = datosProcesosAux.pop(); //se toma el último registro de los errores para la info del encabezado ******VER******

        return (
            <div>
                {data && data.loadingReproceso && <div id="loadingReproceso" className="loading" />}
                <InfoSuperior datosEncabezado={data.datosProcesosEncabezado} datosTraza={datosProcesosAux} />
                <ControlesSuperiores
                    validarProcesoEnEjecucion={this.props.validarProcesoEnEjecucion}
                    RecorrerTabla={this.RecorrerTabla}
                    IdProcesoEstado={datosProcesosAux.IdProcesoEstado}
                    IdProcesoTraza={datosProcesosAux.IdProcesoTraza}
                    erroresProceso={data.erroresProceso}
                    seleccionarTabError={this.props.seleccionarTabError}
                    mostrarModal={this.props.mostrarModal}
                    labels={data.nombresLabelErrores}
                    labelActiva={data.labelErrorActiva}
                    getErroresProceso={this.props.getErroresProceso}
                    DescargarExcelErroresYNotas={this.props.DescargarExcelErroresYNotas}
                />
                {data.checkSinTildar && (
                    <div className="row">
                        {' '}
                        <label className="error lbl-radio label-secondary top-separator-xxs">Las casillas de DESESTIMAR y REPROCESAR deben estar todas seleccionadas según corresponda</label>
                    </div>
                )}
                {data.masDeCienRegistrosDeError && (
                    <div className="row">
                        {' '}
                        <label className="lbl-radio label-secondary top-separator-xxs">Se muestran los primeros 100 errores/notas únicamente</label>
                    </div>
                )}
                <TablaErrores
                    IdProcesoEstado={datosProcesosAux.IdProcesoEstado}
                    IdProcesoTraza={datosProcesosAux.IdProcesoTraza}
                    checkAllError={this.props.checkAllError}
                    checkError={this.props.checkError}
                    data={this.props.data}
                />
                {data.modalConfirmarSalir && <ModalConfirmarSalir getErroresProceso={this.props.getErroresProceso} mostrarModal={this.props.mostrarModal} />}
                {/**
                 * ADT-1220
                 * Adintar17 - Tablero de ejecuciones: No se reprocesa correctamente el archivo cuando se desestiman los registros
                 * Segun hablado con Silvia Serra para reprocesar, se debe por lo menos seleccionar un registro a reprocesar,
                 * si desestima todo debe mostrar una advertencia indicando que por lo menos debe seleccionar un registro a reprocesar
                 * para efectuar la accion de Reprocesar
                 */}
                {data.modalDatosCuenta.mostrar && <ModalDatosCuenta ocultarModal={this.props.ocultarModalDatosCuenta} titulo={data.modalDatosCuenta.titulo} mensaje={data.modalDatosCuenta.mensaje} />}
            </div>
        );
    }
}

export default DetalleErrores;
